<script setup lang="ts">
import { useAuthorImageUrl } from '@shared/app/composables/useAuthorImageUrl';
import type { Author } from '@shared/app/utils/transformToAuthor';

defineProps<{
  author: Author;
}>();

const { createAuthorImageUrl } = useAuthorImageUrl();
</script>

<template>
  <div class="flex gap-5 items-center">
    <div class="w-12 h-12 shrink-0 rounded-full overflow-hidden">
      <img
        v-if="author.profile_image"
        :src="
          createAuthorImageUrl({
            authorId: author.id,
            filename: author.profile_image,
            w: 100,
            h: 100,
          })
        "
        class="w-full h-full object-cover"
      />
      <AtomsPlaceholderImage class="w-full h-full object-cover bg-white" />
    </div>
    <div>
      <p v-if="author.title" class="font-bold text-pink-400 text-sm">
        {{ author.title }}
      </p>
      <p class="text-lg font-bold text-gray-500">
        {{ author.name }}
      </p>
    </div>
  </div>
</template>
